import { RegularButton } from 'fronton-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Styles } from '../styles';

export const DATA_QA_REVIEWS_SHOW_MORE_BUTTON = 'reviews-show-more-button';

export const ReviewsShowMoreButton: React.FC<{
  fetchNext: () => void;
}> = ({ fetchNext }) => {
  const { t } = useTranslation();
  return (
    <RegularButton
      data-qa={DATA_QA_REVIEWS_SHOW_MORE_BUTTON}
      as="button"
      className={Styles.showMoreButton}
      onClick={fetchNext}
      size="l"
      variant="secondary"
    >
      {t('reviews.ui.show-more')}
    </RegularButton>
  );
};
